








































































import CompanySheet from "@/components/company/CompanySheet.vue";
import DropAreaMulti from "@/components/files/DropAreaMulti.vue";
import PreselectTemplateCard from "@/components/partner/PreselectTemplateCard.vue";
import LineItemsForm from "@/components/repair-estimate/LineItemsForm.vue";
import RepairEstimateForm from "@/components/repair-estimate/RepairEstimateForm.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import { CompanyServiceEnum } from "@/lib/enum/company-service.enum";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { formatCurrency } from "@/lib/utility/currency-helper";
import { getAutocompleteFilter } from "@/lib/utility/filter";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { Reference } from "@/models/reference.entity";
import { IRepairEstimate, RepairEstimate } from "@/models/repair-estimate.entity";
import { SignDocument } from "@/models/sign-document.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component({
  components: { PreselectTemplateCard, CompanySheet, MNoContent, LineItemsForm, DropAreaMulti, RepairEstimateForm },
  filters: {}
})
export default class ReportRepairEstimateCreateDialog extends mixins(PermissionMixin, RulesMixin) implements IDialog {
  @Prop({ default: false }) value!: boolean;

  dialog: boolean = this.value;
  readonly getAutocompleteFilter = getAutocompleteFilter;
  readonly formatCurrency = formatCurrency;
  readonly CurrencyEnum = CurrencyEnum;

  workshopEnum = CompanyServiceEnum.WORKSHOP;
  damageBrokerEnum = CompanyServiceEnum.DAMAGE_BROKER;

  requestAt = CompanyServiceEnum.WORKSHOP;

  @Watch("value")
  onValueChange(val: boolean) {
    if (val) {
      this.reset();
    }

    this.dialog = val;

    if (!val) {
      this.reset();
    }
  }

  @Watch("dialog")
  onDialogChange(val: boolean) {
    this.$emit("input", val);
  }

  @Watch("file")
  setEstimateNumber() {
    if (!this.repairEstimate.number && this.file) {
      if (this.file.name?.endsWith(".pdf")) {
        this.repairEstimate.number = this.file.name.substring(0, this.file.name.length - 4);

        return;
      }
      this.repairEstimate.number = this.file.name;

      return;
    }
  }

  repairEstimate: IRepairEstimate = new RepairEstimate({});

  requestsLoading = false;

  file: File | null = null;

  get files(): File[] {
    if (this.file) {
      return [this.file];
    }
    return [];
  }

  set files(files: File[]) {
    if (files.length > 0) {
      this.file = files[0];
    } else {
      this.file = null;
    }
  }

  get partner() {
    return PartnerModule.partner;
  }

  get report() {
    return PartnerModule.report;
  }

  get context() {
    return {
      repairEstimate: this.repairEstimate,
      partner: this.partner,
      report: this.report
    };
  }

  get validForm() {
    return this.report.workshopCompanyId || this.report.damageBrokerCompanyId;
  }

  get myUserId() {
    return UserModule.userId;
  }

  async create() {
    this.requestsLoading = true;
    if (this.repairEstimate.id) {
      throw new Error("Repair estimate request ID is already defined");
    }

    const isWorkshop = this.requestAt === CompanyServiceEnum.WORKSHOP;
    const sellerCompanyId = isWorkshop ? this.report.workshopCompanyId : this.report.damageBrokerCompanyId;

    if (!sellerCompanyId) {
      throw new Error(
        isWorkshop
          ? "Workshop company ID is not defined in the report"
          : "Damage broker company ID is not defined in the report"
      );
    }

    if (isWorkshop) {
      if (!this.report.workShopCompany) {
        await this.report.fetchWorkshopEntity();
      }
      if (!this.report.workShopCompany) {
        throw new Error("Error loading workshop entity");
      }
    } else {
      if (!this.report.damageBrokerCompany) {
        await this.report.fetchDamageBrokerEntity();
      }
      if (!this.report.damageBrokerCompany) {
        throw new Error("Error loading damage broker entity");
      }
    }

    const sellerCompany = isWorkshop ? this.report.workShopCompany : this.report.damageBrokerCompany;

    if (!sellerCompany) {
      throw new Error("Seller company entity is not defined");
    }

    try {
      const refs = [];
      refs.push(new Reference({ refId: this.report.id, refType: ResourceEnum.REPORT }));

      if (this.report.vehicleId) {
        refs.push(new Reference({ refId: this.report.vehicleId, refType: ResourceEnum.VEHICLE }));
      }

      this.repairEstimate.reportId = this.report.id;
      this.repairEstimate.partnerId = this.report.partnerId;
      this.repairEstimate.seller = sellerCompany.invoiceParty;
      this.repairEstimate.refs = refs;

      if (this.myUserId) {
        this.repairEstimate.assignees = [this.myUserId];
      }

      const repairEstimate = await this.repairEstimate.create();

      refs.push(new Reference({ refId: repairEstimate.id, refType: ResourceEnum.REPAIR_ESTIMATE }));

      if (this.file) {
        const signDocument = new SignDocument({
          name: this.file.name,
          title: this.file.name,
          isTemplate: false,
          folder: "/repair-estimate/",
          refs: refs,
          file: this.file,
          partnerId: this.partner.id
        });

        await signDocument.create();

        await this.repairEstimate.updatePartial({
          documentId: signDocument.id,
          status: RequestStatusEnum.REPLIED
        });
        this.repairEstimate.document = signDocument;
      }

      this.report.repairEstimates.unshift(this.repairEstimate);
    } catch (e) {
      handleError(e);
    } finally {
      this.close();
      this.requestsLoading = false;
    }

    return {
      repairEstimate: this.repairEstimate
    };
  }

  open() {
    this.dialog = true;
  }

  close() {
    this.dialog = false;
  }

  reset() {
    this.file = null;
    this.repairEstimate = new RepairEstimate({
      partnerId: this.partner.id
    });
    this.repairEstimate.setDefaultLineItems();
    if (this.report.damageBrokerCompanyId) {
      this.requestAt = CompanyServiceEnum.DAMAGE_BROKER;
    } else {
      this.requestAt = CompanyServiceEnum.WORKSHOP;
    }
  }
}
